import {UserPlatformRole} from '../models/user';

interface SchemaProperty {
  enum?: string[];
  enumByRole?: Record<string, string[]>;
  [key: string]: any;
}

/**
 * Returns enum values for a schema property, filtered by user role if enumByRole is present.
 * Falls back to the default enum if no match.
 *
 * @param propertySchema Schema property definition
 * @param userRole Current user role (string or UserPlatformRole)
 * @returns Array of allowed enum values
 */
export function getEnumByRole(propertySchema: SchemaProperty | null | undefined, userRole?: UserPlatformRole): string[] {
  if(!propertySchema) {
    return [];
  }
  // If enumByRole exists, use it to filter by role
  if(propertySchema.enumByRole && typeof propertySchema.enumByRole === 'object') {
    const roleKey = userRole ?? 'default';
    // Try to get the enum for the specific role
    if(Array.isArray(propertySchema.enumByRole[roleKey])) {
      return propertySchema.enumByRole[roleKey];
    }
    // Fall back to 'default' enum if specific role not found
    if(Array.isArray(propertySchema.enumByRole.default)) {
      return propertySchema.enumByRole.default;
    }
  }
  // Fall back to the regular enum if enumByRole is not available or has no matching role
  if(Array.isArray(propertySchema.enum)) {
    return propertySchema.enum;
  }
  return [];
}
